/**
 * KeyPad enums
 */

export enum KeypadValueType {
  INTEGER = 'integer',
  FLOAT = 'float',
  STRING = 'string',
}

export enum KeypadAction {
  POP = 'pop',
  PUSH = 'push',
}

export enum KeypadButtonAction {
  PUSH = 'push',
  BLANK = 'blank',
}
